import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ConfigService } from './services/config.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { FormRenderComponent } from './dynamic-form/containers/form-render/form-render.component';
declare var $: any;
declare var ira: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'render-form',
    templateUrl: './render-form.component.html',
    styleUrls: ['./render-form.component.css']
})
export class RenderFormComponent implements OnInit {

    config: any[] = [];

    formName: string;
    formDescription: string;
    @ViewChild(FormRenderComponent, { static: false }) private _childFormPreview: FormRenderComponent;

    @Output()
    formSubmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(private configService: ConfigService, private http: HttpClient) {
        this.configService
            .getRenderFormFields()
            .subscribe(
                form => {
                    const my_current_form = JSON.parse(form.toString());
                    
                    if (my_current_form.formJson != null) {
                        //my_current_form.formJsonString = my_current_form.formJsonString.replace(/&quot;/g, '"');
                        my_current_form.formJson = JSON.parse(my_current_form.formJsonString);
                        //05/08/2021 - We have to set this here, since if it is not set
                        //It will hide the label for infoMessage and Terms checkbox controls in the render/preview view
                        my_current_form.formJson.map(x => x.controlType = "preview");
                        var candidateId = $("#hdnCandidateId").val();

                        if (candidateId > 0) {
                            my_current_form.formJson.filter(x => x.name === "applicationFirstName")
                                .map(x => {
                                    x.value = $("#hdnCandidateFirstName").val();
                                    x.disabled = false;
                                });
                            my_current_form.formJson.filter(x => x.name === "applicationLastName")
                                .map(x => {
                                    x.value = $("#hdnCandidateLastName").val();
                                    x.disabled = false;
                                });
                            my_current_form.formJson.filter(x => x.name === "applicationEmailAddress")
                                .map(x => {
                                    x.value = $("#hdnCandidateEmailAddress").val();
                                    x.disabled = true;
                                });
                            my_current_form.formJson.filter(x => x.name === "applicationMobilePhone")
                                .map(x => {
                                    x.value = $("#hdnCandidateMobilePhone").val();
                                    x.disabled = false;
                                });
                        }
                        this.configService.editConfig([...my_current_form.formJson]);
                        this.formName = my_current_form.name || '';
                        this.formDescription = my_current_form.description || '';
                    }
                },
                error => {
                    console.error(error);
                    this.configService.editConfig([]);
                }
            )
    }

    ngOnInit() {
        this.configService.cast.subscribe(config => this.config = [...config]);
    }

    formSubmitted(formFieldValues) {
        
        const submittedValues = { ...formFieldValues };

        // Replace truthy checkbox values with corresponding text value
        const checkboxValues = this.configService.allCheckboxValues;
        Object.keys(checkboxValues).map(key => {
            submittedValues[key] = checkboxValues[key].join(", ");
        });

        Object.keys(submittedValues).map(key => {
            if(Array.isArray(submittedValues[key])){
                submittedValues[key] = "";
            }
        });
        // Replace file name with actual File content for all file upload fields
        const fileUploads = this.configService.allUploadedFiles;
        //Object.keys(fileUploads).map(key => {
        //  submittedValues[key] = fileUploads[key]
        //})

        //05/08/2021 - Added support for informational message. We do not need to store this info message along with application form,
        //since this is only for display purposes and the user does not enter or select any input for this control
        //With the filter we are removing the infomessage control from the stored application values
        let fieldsWithValues = this.config.filter(x => x.type !== "infoMessage").map(field => {
            return {
                name: field.name,
                position: field.position,
                type: field.type,
                label: escape(field.label),
                convertToTag: field.convertToTag ? field.convertToTag : false,
                eeo: field.eeo ? field.eeo : false,
                value: field.disabled ? field.value : submittedValues[field.name]
            }
        });

        const userForm = {
            'name': this.formName,
            'description': this.formDescription,
            //'values': submittedValues,
            "cacheKey": $("#hdnCompanyID").val(),
            "jobListId": $("#jobListId").val(),
            "jobTitle": $("#jobTitle").val(),
            "jobApplicationLink": $("#jobApplicationLink").val(),
            "jobKey": $("#jobKey").val(),
            "recaptchaResponse": formFieldValues.recaptcha,
            fieldsWithValues
        };

        const formData: FormData = new FormData();

        var fileProperties: any = [];

        $.each(fileUploads,
            function (index, item) {
                var newItem = {
                    name: item.name,
                    size: item.size,
                    fieldName: item.fieldName,
                    fieldLabel: item.fieldLabel
                }

                fileProperties.push(newItem);

                formData.append("file", item.file);
            });

        formData.append("fileProperties", JSON.stringify(fileProperties));
        formData.append("userForm", JSON.stringify(userForm));

        this.http.post($("#hdnSubmitApplicationUrl").val(), formData).subscribe(resp => {
            var url = $("#hdnAllJobsUrl").val(),
                result = resp.toString();

            if (result !== null && result !== 'undefined' && result !== undefined && result !== '' && result !== ' ') {
                if (result === "-9") {
                    $("#dvError").hide();
                    $('#dvSuccess').show();
                    $(".form-control").val('');
                    $('.btn-primary').prop('disabled', true);
                    $('.custom-file-label').html('Select file...');
                    window.scrollTo(0, 0);
                    this._childFormPreview.submitFailedBlacklist();

                    return true;
                } else {
                    if (!(window.location !== window.parent.location)) {
                        sessionStorage.setItem("iraApplicationId", result);
                    }

                    url += '?showMessage=true&appId=' + encodeURIComponent(result);

                    window.location.href = url;
                }
            } else {
                this._childFormPreview.submitFailed();
                $("#dvError").show();
                $('#dvSuccess').hide();
            }
        });
    }

}
